<div class="flex-direction-column gap-5">
  @if (label) {
    <span class="campo-label">{{ label }}</span>
  }

  <div class="campo-data-container">
    <div class="campo-input-wrapper">
      <img [src]="icone" alt="" class="campo-input-icone" />
      <button type="button" class="campo-input-base campo-input-com-icone campo-data-toggle"
              [class.campo-input-erro]="erro" [disabled]="disabled" (click)="alternar()">
        <span class="campo-data-valor" [class.campo-data-placeholder]="!valor">{{ valorFormatado || 'DD/MM/AAAA' }}</span>
      </button>
    </div>

    @if (aberto()) {
      <div class="campo-data-painel">
        <app-calendario [dataSelecionada]="valor" [dataMinima]="dataMinima" (selecionarData)="aoSelecionar($event)"></app-calendario>
      </div>
    }
  </div>

  @if (erro) {
    <span class="campo-erro-texto">{{ erro }}</span>
  }
</div>
